import { adminApi } from './api';

/* ==========================================
  과제 관리 (Assignment Management)
========================================== */

/**
 * 특정 과정의 과제 목록 조회
 * @param {number} courseId - 과정 ID
 * @returns {Promise<Array>} 과제 목록 배열
 */
export const fetchAssignmentsByCourse = async (courseId) => {
  const response = await adminApi.get(`/api/admin/tasks/courses/${courseId}`);
  return response.data.data;
};

/**
 * 과제 상세 조회
 * @param {number} assignmentId - 과제 ID
 * @returns {Promise<Object>} 과제 상세 정보
 */
export const fetchAssignmentDetail = async (assignmentId) => {
  const response = await adminApi.get(`/api/admin/tasks/${assignmentId}`);
  return response.data.data;
};

/**
 * 과제 생성
 * @param {Object} assignmentData - 과제 데이터
 * @returns {Promise<Object>} response 객체 (Location 헤더 포함)
 */
export const createAssignment = async (assignmentData) => {
  const requestData = {
    videoId: assignmentData.videoId,
    title: assignmentData.title,
    description: assignmentData.description,
    attachedFileUrl: assignmentData.attachedFileUrl,
  };

  // undefined/null 값 제거
  Object.keys(requestData).forEach(key => {
    if (requestData[key] === undefined || requestData[key] === null) {
      delete requestData[key];
    }
  });

  const response = await adminApi.post(`/api/admin/tasks`, requestData);
  // Location 헤더에서 assignmentId 추출을 위해 response 전체 반환
  return response;
};

/**
 * 과제 수정
 * @param {Object} assignmentData - assignmentId 포함
 * @returns {Promise<Object>} 응답 데이터
 */
export const updateAssignment = async (assignmentData) => {
  const requestData = {
    assignmentId: assignmentData.assignmentId,
    videoId: assignmentData.videoId,
    title: assignmentData.title,
    description: assignmentData.description,
    attachedFileUrl: assignmentData.attachedFileUrl,
  };

  // undefined/null 값 제거
  Object.keys(requestData).forEach(key => {
    if (requestData[key] === undefined || requestData[key] === null) {
      delete requestData[key];
    }
  });

  const response = await adminApi.put(`/api/admin/tasks`, requestData);
  return response.data;
};

/**
 * 과제 삭제
 * @param {number} assignmentId - 과제 ID
 * @returns {Promise<void>}
 */
export const deleteAssignment = async (assignmentId) => {
  await adminApi.delete(`/api/admin/tasks/${assignmentId}`);
};
